import styled from 'styled-components';
import { Group } from 'ui';

export const Card = styled(Group)`
  padding: 16px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.dark2};
`;
